import { render, staticRenderFns } from "./device-title.vue?vue&type=template&id=7827fc5e&scoped=true"
import script from "./device-title.vue?vue&type=script&lang=js"
export * from "./device-title.vue?vue&type=script&lang=js"
import style0 from "./device-title.vue?vue&type=style&index=0&id=7827fc5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827fc5e",
  null
  
)

export default component.exports